/**
 * Browse/Results Page Routing
 */

import { Route } from 'found';
import * as React from 'react';

import ResultsPage, { IResultListExposedProps, ResultsPerPage } from '../../components/pages/browse/Results';
import { getQueryStringStateForRoute } from '../../contexts/queryString/helpers';
import { trackSearchQuery } from '../../relay/trackSearch';
import {
  IMatchWithContext,
  LoadingPage,
  PrepareVariablesFunction,
  RenderRouteFunction,
} from '../../utils/router';

interface IVariables extends Required<Pick<GQL.ITrackSearchOnViewerArguments,
  | 'query'
  | 'license_params'
  | 'taxonomy_query'
  | 'sort'
  | 'filters'>> {
  count: number;
}

const prepareVariables: PrepareVariablesFunction<void, IVariables> =
  (_, match: IMatchWithContext) => {
    return {
      ...getQueryStringStateForRoute(match),
      count: ResultsPerPage,
      offset: 0,
    };
  };

const render: RenderRouteFunction<IResultListExposedProps> = ({ Component, props }) => {
  return !!!Component ?
    <LoadingPage />
    : !!!props ?
      <Component viewer={null} searching />
      : <Component {...props} />;
};

export const ResultsPageRoute = (
  <Route
    Component={ResultsPage}
    query={trackSearchQuery}
    prepareVariables={prepareVariables}
    render={render}
  />
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/router/routes/ResultsPage.tsx